/**
 * The api client throws `Error("<status>: <body>")` where body is usually
 * `{"error": "...", "code": "..."}`. This unpacks that into structured fields
 * so UI can show a clean message and branch on `code` (e.g. REAUTH_REQUIRED).
 */
export interface ApiError {
  status?: number;
  message: string;
  code?: string;
  // The full parsed JSON body, for errors that carry payload beyond
  // error/code (e.g. VERSION_CONFLICT's `current` trail).
  body?: unknown;
}

export function parseApiError(err: unknown, fallback = "Something went wrong"): ApiError {
  if (!(err instanceof Error)) return { message: fallback };

  const match = err.message.match(/^(\d+):\s*([\s\S]*)$/);
  const status = match ? Number(match[1]) : undefined;
  const body = match ? match[2] : err.message;

  try {
    const parsed = JSON.parse(body) as { error?: string; code?: string };
    return {
      status,
      message: typeof parsed.error === "string" ? parsed.error : body || fallback,
      code: parsed.code,
      body: parsed,
    };
  } catch {
    return { status, message: body || fallback };
  }
}
